exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".button-exit[data-v-078542e0]{position:absolute;bottom:10px;right:10px;z-index:990;cursor:pointer;user-select:none;-webkit-filter:drop-shadow(1.5px 1.5px 1px #222);filter:drop-shadow(1.5px 1.5px 1px #222)}.button-exit.disabled[data-v-078542e0]{display:none;pointer-events:none}.button-title[data-v-078542e0]{position:absolute;bottom:6px;right:40px;z-index:999;font-size:13px;text-decoration:none;color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-078542e0","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ButtonExit.vue
// module id = 71
// module chunks = 0